var map = {
	"./api.base.js": 55442,
	"./apisetup.js": 8076,
	"./dev.endpoints.js": 47522,
	"./devapis/applications.api.js": 22703,
	"./devapis/customer.api.js": 38592,
	"./devapis/leads.api.js": 15113,
	"./devapis/masterdata.api.js": 25458,
	"./devapis/underwriter.api.js": 74095,
	"./endpoints.js": 6151,
	"./index.js": 82581,
	"./prod.endpoints.js": 22584,
	"./staging.endpoints.js": 24864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75135;